import React from 'react';
import { motion } from 'framer-motion';
import { XIcon } from 'lucide-react';
const routine = ['Searching.', 'Organizing.', 'Adapting.', 'Creating.', 'Repeating.'];
const problems = ['Hours spent searching for teaching material', 'Demonstrations prepared at the last minute', 'Lessons that feel repetitive', 'No clear progression between classes', 'Difficulty correcting student mistakes', 'Scattered resources', 'Too much preparation outside class', 'No complete teaching system'];
const ease = [0.23, 1, 0.32, 1] as const;
export function PainPoints() {
  return <section className="bg-blush px-4 py-20 sm:py-28" data-id="element-146" data-mp="1o03fdnmi7lmu">
      <div className="mx-auto max-w-5xl" data-id="element-147" data-mp="1o1oc9jwajgnv">
        <div className="mx-auto max-w-3xl text-center" data-id="element-148" data-mp="1sy50ee3hpv0y">
          <h2 className="font-serif text-4xl font-semibold leading-tight text-espresso sm:text-5xl" data-id="element-149" data-mp="1t0r6e9aqg2h2">
            Still Spending Hours Planning Every Pastry Class?
          </h2>
        </div>
        <div className="mt-12 grid gap-10 lg:grid-cols-[1.1fr_1fr] lg:items-start" data-id="element-150" data-mp="3nbwgnwgbrd5d">
          <motion.div initial={{
          opacity: 0,
          y: 16
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.3,
          ease
        }} className="rounded-2xl border border-champagne bg-cream-light p-6 text-base leading-7 text-cocoa sm:p-8" data-id="element-151" data-mp="1yz3wwyc1o4gu">
            <p className="font-semibold text-espresso" data-id="element-152" data-mp="23trcu8szfqjt">
              Tomorrow you have a pastry class.
            </p>
            <p className="mt-4" data-id="element-153" data-mp="1b2zilgvh9bz4">
              But tonight you are still searching for techniques,
              demonstrations, student activities, assessment ideas and ways to
              explain everything clearly.
            </p>
            <p className="mt-4" data-id="element-154" data-mp="1k2mmqaflcvvv">
              Not because you do not know pastry.{' '}
              <strong className="font-semibold text-espresso" data-id="element-155" data-mp="30gmjxdn1y7ff">
                You know your craft.
              </strong>
            </p>
            <p className="mt-4" data-id="element-156" data-mp="2vib6ksxjtesg">
              The problem is that you are still building every class from
              scratch.
            </p>
            <p className="mt-4 flex flex-wrap gap-x-3 gap-y-1 font-serif text-xl italic text-espresso" data-id="element-157" data-mp="1y3qa65w9rdjv">
              {routine.map(word => <span key={word} data-id="element-158" data-mp="226mmxfz4offw">{word}</span>)}
            </p>
            <p className="mt-5 font-semibold text-raspberry" data-id="element-159" data-mp="273muxwfjfs9n">
              Pastry Instructor Ready was created to change that.
            </p>
          </motion.div>
          <ul className="grid gap-3" data-id="element-160" data-mp="1efzb4jm3d5o2">
            {problems.map((problem, index) => <motion.li key={problem} initial={{
            opacity: 0,
            x: 12
          }} whileInView={{
            opacity: 1,
            x: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.25,
            delay: index * 0.04,
            ease
          }} className="flex items-center gap-3 border-b border-blush-line pb-3 text-sm font-medium leading-6 text-espresso" data-id="element-161" data-mp="1jfbwt11886p2" data-mpi={index}>
                <span className="flex h-7 w-7 shrink-0 items-center justify-center rounded-full bg-raspberry-soft text-raspberry" data-id="element-162" data-mp="o6rvmftclny0">
                  <XIcon size={14} strokeWidth={2.6} aria-hidden="true" data-id="element-163" data-mp="j8gkm1rbh7e7" />
                </span>
                {problem}
              </motion.li>)}
          </ul>
        </div>
        <p className="mx-auto mt-14 max-w-3xl border-t border-champagne pt-10 text-center font-serif text-3xl font-semibold text-espresso sm:text-4xl" data-id="element-164" data-mp="a5fjygl808hx">
          Stop rebuilding every pastry class from zero.
        </p>
      </div>
    </section>;
}